<template>
    <ui-modal title="Szczegóły worka" :closeable="true">
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Szczegóły worka'" />
            <h5 class="mb-0 text-center" v-text="`ID ${bag.package_id}`" />
        </template>

        <h5 v-text="'Dane podstawowe'" class="bag-details__header" />

        <div class="bag-basics bag-details-frame text-primary">
            <div class="bag-basics__col">
                <div v-text="'Status'" />
                <span
                    class="status"
                    :class="{ 'is-success': isOpen, 'is-unavailable': !isOpen }"
                    v-text="isOpen ? 'Otwarty' : 'Zamknięty'"
                />
            </div>

            <div class="bag-basics__col">
                <div v-text="'Frakcja'" />
                <fraction-label :fraction="fraction" />
            </div>

            <div class="bag-basics__col">
                <div v-text="'Wartość'" />
                <div>
                    <strong v-text="total" /> ({{ quantity }} szt.)
                </div>
            </div>

            <div class="bag-basics__col">
                <div v-text="'Nr plomby'" />
                <div>
                    <span v-html="$options.sealNumber(bag.seal_number, shouldHighlightSealPrefix)" />
                    <div v-if="!isOpen" v-text="operatorName" />
                </div>
            </div>
        </div>

        <h5 v-text="'Akcje na worku'" class="bag-details__header mt-5" />

        <div class="bag-details-actions bag-details-frame text-primary">
            <div class="bag-details-actions__col mb-3">
                <h6 v-text="'Otwarcie'" class="font-weight-normal" />

                <div>
                    <strong v-text="'Data'" /><br />
                    <template v-if="bag.opened_at">
                        {{ $moment(bag.opened_at).format('DD-MM-YYYY HH:mm') }}
                    </template>
                    <template v-else>
                        ---
                    </template>
                </div>

                <div>
                    <strong v-text="'ID urządzenia'" /><br />
                    {{ bag.mcuid || '---' }}
                </div>

                <div>
                    <strong v-text="'Otwarty przez'" /><br />
                    {{ bag.device_alias || '---' }}
                </div>

                <div>
                    <strong v-text="'Typ urządzenia'" /><br />
                    {{ openingDeviceType }}
                </div>
            </div>
            <div class="bag-details-actions__col mb-3">
                <h6 v-text="'Zamknięcie'" class="font-weight-normal" />

                <div>
                    <strong v-text="'Data'" /><br />
                    <template v-if="bag.closed_at">
                        {{ $moment(bag.closed_at).format('DD-MM-YYYY HH:mm') }}
                    </template>
                    <template v-else>
                        ---
                    </template>
                </div>

                <div v-if="!wasClosedByCurrentUser">
                    <strong v-text="'ID urządzenia'" /><br />
                    {{ bag.mcuid_that_closed || '---' }}
                </div>

                <div>
                    <strong v-text="'Zamknięty przez'" /><br />
                    {{ closedBy }}
                </div>
            </div>
        </div>

        <div class="bag-eans">
            <h5 v-text="`Zawartość worka (${quantity} szt.)`" />
            <the-btn
                text="Pokaż zawartość"
                class="btn-custom-gray btn-sm"
                :icon="showDetails ? 'ArrowUp' : 'ArrowDown'"
                @click="showDetails = !showDetails"
            />
        </div>

        <div v-if="showDetails" class="bag-details-frame">
            <bag-eans :bag="bag" />
        </div>
    </ui-modal>
</template>

<script>
import sealNumber from '@/helpers/seal-number'
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'
import { DEVICE_TYPES } from '@/utils/constants/drs/store-devices'

export default {
    sealNumber,

    mixins: [bagsMixin],

    data: () => ({
        showDetails: false
    }),

    computed: {
        bag() {
            return this.$store.getters.getModal.args.bag
        },

        openingDeviceType() {
            const deviceType = DEVICE_TYPES.find(({ value }) => value === this.bag.device_type)

            return deviceType?.label || this.bag.device_type || '---'
        },

        wasClosedByCurrentUser() {
            const currentUserEmail = this.$store.getters.getUser?.email

            return currentUserEmail && this.bag.cashier === currentUserEmail
        },

        closedBy() {
            const { cashier, device_alias_that_closed } = this.bag

            // Mobile app login is always an 8-digit number (e.g. "12345678")
            const isMobileAppLogin = /^\d{8}$/.test(cashier)

            // If cashier is missing or is a mobile app login, display device_alias_that_closed
            if (!cashier || isMobileAppLogin) {
                return device_alias_that_closed || '---'
            }

            return cashier
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';

.bag-details {
    &__header {
        margin-bottom: 1rem;
        font-size: 18px;
        font-weight: 400;
    }
}

.bag-details-frame {
    border: 1px solid var(--color-gray-200);
    border-radius: 0.5rem;
    padding: 1rem;
}

.bag-basics {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-bottom: 2rem;
    width: 100%;

    &__col {
        flex: 1 1 200px;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}

.bag-details-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-bottom: 2rem;

    &__col {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}

.bag-eans {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background-color: var(--color-white);
    position: sticky;
    padding: 1rem;
    top: -18px;
    z-index: 1;
}
</style>